import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Notification from '../../components/Notification/Notification';
import './ConfirmOTP.css';
import publicAxios from '../../utils/axios/publicAxios';

const ConfirmOTP = () => {
  const navigate = useNavigate();
  const [otp, setOTP] = useState('');
  const [notification, setNotification] = useState({ type: '', message: '' });

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification({ type: '', message: '' });
    }, 5000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem('pendingUserId');
    if (!userId) {
      showNotification('error', 'Session expired. Please sign up again.');
      return;
    }

    try {
      const res = await publicAxios.post('/public/confirm-otp', { userId, otp });

      showNotification('success', res.data.message || 'OTP verified successfully.');
      localStorage.removeItem('pendingUserId');

      setTimeout(() => navigate('/login'), 2500);
    } catch (error) {
      console.error('OTP confirmation error:', error.response?.data || error.message);
      showNotification(
        'error',
        error.response?.data?.message || 'Failed to confirm OTP. Please try again.'
      );
    }
  };

  return (
    <div className="confirm-otp">
      <Notification
        type={notification.type}
        message={notification.message}
        onClose={() => setNotification({ type: '', message: '' })}
      />
      <h2>Confirm OTP</h2>

      <p>Please check your email for your OTP (One Time Password). <span>It will expire in 1 hour.</span></p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOTP(e.target.value)}
          required
        />
        <button type="submit">Verify</button>
      </form>
    </div>
  );
};

export default ConfirmOTP;